// extracted by mini-css-extract-plugin
export default {"root":"stippedTable_root__Id1-I","root_table":"stippedTable_root_table__kjYyt","td_left":"stippedTable_td_left__JP2IP"};